import DashboardInfoCard from "@/components/DashboardPage/DashboardInfoCard";
import DashboardTicketCard from "@/components/DashboardPage/DashboardTicketsCard";
import DashboardAuthorizationCard from "@/components/DashboardPage/DashboardAuthorizationCard";
import DashboardTransactionsCard from "@/components/DashboardPage/DashboardTransactionsCard";
import DashboardBannerCard from "@/components/DashboardPage/DashboardBannerCard";
import DashboardCurrenciesCard from "@/components/DashboardPage/DashboardCurrenciesCard";
import DashboardReferralCard from "@/components/DashboardPage/DashboardReferralCard";
import DashboardGuideCard from "@/components/DashboardPage/DashboardGuideCard";
import DashboardPMCard from "@/components/DashboardPage/DashboardPMCard";
import DashboardScores from "@/components/DashboardPage/DashboardScores";
import DashboardMarketBanner from "@/components/DashboardPage/DashboardMarketBanner";
import DashboardDiscountCode from "@/components/DashboardPage/DashboardDiscountCode";
import DashboardHeaderActions from "@/components/DashboardPage/DashboardHeaderActions";

import { mapGetters } from "vuex";
import * as types from "@/store/types";

export default {
  name: "dashboard-page",
  components: {
    DashboardInfoCard,
    DashboardTicketCard,
    DashboardAuthorizationCard,
    DashboardTransactionsCard,
    DashboardBannerCard,
    DashboardCurrenciesCard,
    DashboardReferralCard,
    DashboardGuideCard,
    DashboardPMCard,
    DashboardMarketBanner,
    DashboardScores,
    DashboardDiscountCode,
    DashboardHeaderActions
  },
  props: [],
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      getVerifyData: types.userVerifyInfo.getters.GET_USER_VERIFY_INFO,
      userInfo: types.userInfo.getters.GET_USER_INFO
    })
  },
  methods: {}
};
